<template>
  <header class="top-nav" :class="{ 'menu-open': isMenuOpen }">
    <router-link to="/" class="nav-logo fade-in" aria-label="Studio Butter home" @click="closeMenu">
      <img :src="logo" alt="Studio Butter" />
    </router-link>

    <button
      class="menu-toggle fade-in"
      :aria-expanded="isMenuOpen"
      aria-controls="primary-nav"
      aria-label="Toggle menu"
      @click="isMenuOpen = !isMenuOpen"
    >
      <span></span>
      <span></span>
    </button>

    <nav id="primary-nav" class="nav-links">
      <router-link
        v-for="(link, index) in links"
        :key="link.path"
        :to="link.path"
        class="nav-link fade-in"
        :style="{ '--delay': `${0.15 + index * 0.08}s` }"
        @click="closeMenu"
      >
        {{ link.label }}
      </router-link>
      <a
        href="mailto:hellohi@studiobutter.co"
        class="nav-link fade-in"
        :style="{ '--delay': `${0.15 + links.length * 0.08}s` }"
      >
        Contact
      </a>
      <a
        href="https://www.instagram.com/studio_butter_/"
        target="_blank"
        rel="noopener"
        class="nav-link nav-instagram fade-in"
        :style="{ '--delay': `${0.15 + (links.length + 1) * 0.08}s` }"
        aria-label="Studio Butter on Instagram"
      >
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
          <rect x="3" y="3" width="18" height="18" rx="5" />
          <circle cx="12" cy="12" r="4" />
          <circle cx="17.5" cy="6.5" r="0.75" fill="currentColor" stroke="none" />
        </svg>
      </a>
    </nav>
  </header>
</template>

<script>
import logo from "@/assets/studio-butter-favicon.png";

export default {
  name: "TopNav",
  data() {
    return {
      logo,
      isMenuOpen: false,
      links: [
        { label: "Space", path: "/the-space" },
        { label: "Services", path: "/booking" },
        { label: "Gallery", path: "/gallery" },
        { label: "FAQ’s", path: "/faqs" },
      ],
    };
  },
  methods: {
    closeMenu() {
      this.isMenuOpen = false;
    },
  },
};
</script>

<style scoped>
.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: var(--nav-height);
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--color-paper);
  font-family: "haffer-light";
}

.nav-logo img {
  display: block;
  height: 44px;
  width: 44px;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 36px;
}

.nav-link {
  position: relative;
  color: black;
  text-decoration: none;
  font-size: 15px;
  letter-spacing: 0.04em;
  padding: 4px 0;
  transition: color 0.3s ease;
}

/* Underline that draws in from the left on hover and stays on the active page */
.nav-link:not(.nav-instagram)::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: currentColor;
  transform: scaleX(0);
  transform-origin: right;
  transition: transform 0.4s ease;
}

.nav-link:hover::after,
.nav-link.router-link-active::after {
  transform: scaleX(1);
  transform-origin: left;
}

.nav-link:hover {
  color: var(--color-maroon);
}

.nav-instagram {
  display: flex;
}

/* Staggered fade-in on page load */
.fade-in {
  opacity: 0;
  animation: nav-fade-in 0.8s ease forwards;
  animation-delay: var(--delay, 0s);
}

@keyframes nav-fade-in {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile menu */
.menu-toggle {
  display: none;
  position: relative;
  width: 28px;
  height: 20px;
  background: none;
  border: none;
  cursor: pointer;
}

.menu-toggle span {
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: black;
  transition: transform 0.35s ease, top 0.35s ease;
}

.menu-toggle span:first-child {
  top: 6px;
}

.menu-toggle span:last-child {
  top: 14px;
}

.menu-open .menu-toggle span:first-child {
  top: 10px;
  transform: rotate(45deg);
}

.menu-open .menu-toggle span:last-child {
  top: 10px;
  transform: rotate(-45deg);
}

@media (max-width: 899px) {
  .top-nav {
    padding: 0 20px;
  }

  .nav-logo img {
    height: 36px;
    width: 36px;
  }

  .menu-toggle {
    display: block;
  }

  .nav-links {
    position: fixed;
    top: var(--nav-height);
    left: 0;
    right: 0;
    height: calc(100vh - var(--nav-height));
    flex-direction: column;
    justify-content: center;
    gap: 32px;
    background-color: var(--color-paper);
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: opacity 0.4s ease, transform 0.4s ease, visibility 0.4s;
  }

  .menu-open .nav-links {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  .nav-link {
    font-size: 22px;
  }

  /* Links only fade in when the menu opens, not on page load */
  .nav-links .fade-in {
    animation: none;
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .fade-in {
    animation: none;
    opacity: 1;
  }

  .nav-links,
  .menu-toggle span,
  .nav-link::after {
    transition: none;
  }
}
</style>
